import React from "react";
import { TableRow, TableCell, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  statusHead: {
    backgroundColor: theme.statusHeadFontColor,
  },
  delayStopStatusHead: {
    backgroundColor: theme.delayStatusHeadColor,
  },
  statusHeadHeight: {
    height: "24px",
  },
  statusHeaderCell: {
    color: theme.proNumbers,
    borderBottom: 0,
    fontSize: "12px",
    paddingLeft: "10px",
  },
  delayStopStatusHeaderCell: {
    color: theme.error,
    borderBottom: 0,
    fontSize: "12px",
    paddingLeft: "10px",
  },
  customerName: {
    float: "left",
    paddingLeft: "10px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontWeight: 500,
    lineHeight: "17px",
    width: "130px",
    textOverflow: "ellipsis",
  },
});

const UnAssignPickup = ({ classes, unAssignDriver, stopData, isDelayStop }) => {
  return (
    <TableRow
      className={`${classes.statusHeadHeight} ${
        isDelayStop ? classes.delayStopStatusHead: classes.statusHead
      }`}
    >
      <TableCell
        colSpan={2}
        className={
          isDelayStop
            ? classes.delayStopStatusHeaderCell
            : classes.statusHeaderCell
        }
      >
        <div
          className={classes.customerName}
          onClick={() => unAssignDriver(stopData)}
        >
          Click to unassign
        </div>
      </TableCell>
    </TableRow>
  );
};

export default withStyles(styles)(UnAssignPickup);
